import { useCallback } from 'react';
import { openBrowserAsync } from 'expo-web-browser';

export const useAccountLinks = () => {
  const handleTermsLink = useCallback(() => {
    void openBrowserAsync(TERMS);
  }, []);

  const handlePrivacyLink = useCallback(() => {
    void openBrowserAsync(PRIVACY);
  }, []);

  const handlePersonalInfoLink = useCallback(() => {
    void openBrowserAsync(PERSONAL);
  }, []);

  return {
    handleTermsLink,
    handlePrivacyLink,
    handlePersonalInfoLink,
  };
};

const TERMS = 'https://www.sweetgreen.com/terms';
const PRIVACY = 'https://www.sweetgreen.com/privacy-policy';
const PERSONAL = 'https://www.sweetgreen.com/privacy-policy/ca-data-opt-out';
